export default {
      id: "user_circle-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#user_circle",
      toString: function () {
        return this.url;
      }
    }